import { createContext, useContext, useMemo, useState } from "react";

const StateContext = createContext({
  user: null,
  role: null,
  accessToken: null,
  setUser: () => {},
  setAccessToken: () => {},
  setRole: () => {},
  appTheme: {},
  setAppTheme: () => {},
});

export const ContextProvider = ({ children }) => {
  const [user, _setUser] = useState(null);
  const [accessToken, _setAccessToken] = useState(
    localStorage.getItem("ACCESS_TOKEN")
  );

  const [role, _setRole] = useState(localStorage.getItem("ROLE"));
  const [appTheme, setAppTheme] = useState({
    primary: localStorage.getItem("PRIMARY_HOVER") || "#1284ec",
    primaryDark: localStorage.getItem("PRIMARY_COLOR") || "#0a79de",
  });

  const setAccessToken = (accessToken) => {
    _setAccessToken(accessToken);
    if (accessToken) {
      localStorage.setItem("ACCESS_TOKEN", accessToken);
    } else {
      localStorage.removeItem("ACCESS_TOKEN");
    }
  };

  const setUser = (data) => {
    _setUser(data);
  };

  const setRole = (data) => {
    _setRole(data);
    data ? localStorage.setItem("ROLE", data) : localStorage.removeItem("ROLE");
  };

  const value = useMemo(
    () => ({
      accessToken,
      user,
      setAccessToken,
      setUser,
      role,
      setRole,
      appTheme,
    }),
    [accessToken, user, role]
  );

  return (
    <StateContext.Provider value={value}>{children}</StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
